function renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  function renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }



$(document).ready(function() {
  console.log('ready');
  console.log( $('.tag-item'));
  console.log(window.location.href.split("/"));
  $('.tag-item').click(function() {
    console.log(this.checked);
    let checkedValues = [];
    $('.tag-item:checkbox:checked').each(function() {
      checkedValues.push($(this).val());
    });
    let parts = window.location.href.split("/");
	const lastSlashIndex = window.location.href.lastIndexOf("/");
	let baseUrl = parts.length > 5 ? window.location.href.substring(0, lastSlashIndex) : window.location.href; // Get the base URL
    let queryString = "";

    if (checkedValues.length > 0) {
        queryString = "/" + checkedValues.map(value =>  value).join("+");
    }


    let updatedUrl = baseUrl + queryString;
	
	const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }
	
	 if (window.history && window.history.pushState) {
      window.history.pushState(null, document.title, updatedUrl);
    } else {
      // For older browsers that don't support pushState, you might have to use a hash-based approach
      window.location.hash = queryString; // Or a similar hash-based solution
    }

    $.ajax({
      url: updatedUrl,
      type: 'GET',
      dataType: 'html', // Expect HTML response
      success: function(html) {
        // Find the specific element(s) you want to update.  Replace '#content' with the actual selector
        // for the container where you want to update the HTML.  It could be a class, an ID, etc.
        //$('#content').html(response); // Update the content with the new HTML
		renderProductGridContainer(html);
        renderProductCount(html);
        //Important: Re-bind the change event to the checkboxes within the newly loaded content.
        //Otherwise, the checkboxes in the updated content won't trigger the AJAX call.
/*$('input[type="checkbox"]').change(function() { // Re-bind the change event
            //Call the function again, recursively.
            checkboxChangeHandler();
        });*/

      },
      error: function(error) {
        console.error("Error fetching URL:", error);
        // Handle errors, e.g., display an error message
        $('#content').html("<p>Error loading content.</p>");
      }
    });

    function checkboxChangeHandler(){
        let checkedValues = [];
        $('input[type="checkbox"]:checked').each(function() {
          checkedValues.push($(this).val());
        });

        let baseUrl = window.location.href.split('?')[0]; // Get the base URL
        let queryString = "";

        if (checkedValues.length > 0) {
            queryString = "?" + checkedValues.map(value => "filter=" + value).join("&");
        }


        let updatedUrl = baseUrl + queryString;

        $.ajax({
          url: updatedUrl,
          type: 'GET',
          dataType: 'html', // Expect HTML response
          success: function(response) {
            // Find the specific element(s) you want to update.  Replace '#content' with the actual selector
            // for the container where you want to update the HTML.  It could be a class, an ID, etc.
            $('#content').html(response); // Update the content with the new HTML

            //Important: Re-bind the change event to the checkboxes within the newly loaded content.
            //Otherwise, the checkboxes in the updated content won't trigger the AJAX call.
            $('input[type="checkbox"]').change(function() { // Re-bind the change event
                //Call the function again, recursively.
                checkboxChangeHandler();
            });

          },
          error: function(error) {
            console.error("Error fetching URL:", error);
            // Handle errors, e.g., display an error message
            $('#content').html("<p>Error loading content.</p>");
          }
        });
    }
  });

    $('.tag-item-mobile').click(function() {
    console.log(this.checked);
    let checkedValues = [];
    $('.tag-item-mobile:checkbox:checked').each(function() {
      checkedValues.push($(this).val());
    });
    let parts = window.location.href.split("/");
	const lastSlashIndex = window.location.href.lastIndexOf("/");
	let baseUrl = parts.length > 5 ? window.location.href.substring(0, lastSlashIndex) : window.location.href; // Get the base URL
    let queryString = "";

    if (checkedValues.length > 0) {
        queryString = "/" + checkedValues.map(value =>  value).join("+");
    }


    let updatedUrl = baseUrl + queryString;
	
	const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }
	
	 if (window.history && window.history.pushState) {
      window.history.pushState(null, document.title, updatedUrl);
    } else {
      // For older browsers that don't support pushState, you might have to use a hash-based approach
      window.location.hash = queryString; // Or a similar hash-based solution
    }

    $.ajax({
      url: updatedUrl,
      type: 'GET',
      dataType: 'html', // Expect HTML response
      success: function(html) {
        // Find the specific element(s) you want to update.  Replace '#content' with the actual selector
        // for the container where you want to update the HTML.  It could be a class, an ID, etc.
        //$('#content').html(response); // Update the content with the new HTML
		renderProductGridContainer(html);
        renderProductCount(html);
        //Important: Re-bind the change event to the checkboxes within the newly loaded content.
        //Otherwise, the checkboxes in the updated content won't trigger the AJAX call.
/*$('input[type="checkbox"]').change(function() { // Re-bind the change event
            //Call the function again, recursively.
            checkboxChangeHandler();
        });*/

      },
      error: function(error) {
        console.error("Error fetching URL:", error);
        // Handle errors, e.g., display an error message
        $('#content').html("<p>Error loading content.</p>");
      }
    });

    function checkboxChangeHandler(){
        let checkedValues = [];
        $('input[type="checkbox"]:checked').each(function() {
          checkedValues.push($(this).val());
        });

        let baseUrl = window.location.href.split('?')[0]; // Get the base URL
        let queryString = "";

        if (checkedValues.length > 0) {
            queryString = "?" + checkedValues.map(value => "filter=" + value).join("&");
        }


        let updatedUrl = baseUrl + queryString;

        $.ajax({
          url: updatedUrl,
          type: 'GET',
          dataType: 'html', // Expect HTML response
          success: function(response) {
            // Find the specific element(s) you want to update.  Replace '#content' with the actual selector
            // for the container where you want to update the HTML.  It could be a class, an ID, etc.
            $('#content').html(response); // Update the content with the new HTML

            //Important: Re-bind the change event to the checkboxes within the newly loaded content.
            //Otherwise, the checkboxes in the updated content won't trigger the AJAX call.
            $('input[type="checkbox"]').change(function() { // Re-bind the change event
                //Call the function again, recursively.
                checkboxChangeHandler();
            });

          },
          error: function(error) {
            console.error("Error fetching URL:", error);
            // Handle errors, e.g., display an error message
            $('#content').html("<p>Error loading content.</p>");
          }
        });
    }
  });
 /* $('.facets__disclosure-vertical').click(function(){
     var $clickedDiv = $(this);

    // Find the <i> tag with the class 'icon-caret' WITHIN the clicked div
    var $icon = $clickedDiv.find('i.icon-caret');

    // Now proceed with your toggling logic
    if ($icon.hasClass('icon-plus')) {
      $icon.removeClass('icon-plus').addClass('icon-minus');
    } else {
      $icon.removeClass('icon-minus').addClass('icon-plus');
    }
  });*/
});